import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-residency-offline',
  templateUrl: './residency-offline.component.html',
  styleUrls: ['./residency-offline.component.scss']
})
export class ResidencyOfflineComponent {
  @Output() action: EventEmitter<void>;

  constructor() { 
    this.action = new EventEmitter<void>();
  }

  submit(): void {
    this.action.next();
  }
}
